<template>
    <section class="index-scroll-section" :class="classes">
        <slot />
    </section>
</template>

<script setup lang="ts">
    const props = withDefaults(defineProps<{
        color?: 'white' | 'blue'
        border?: 'top' | 'full'
    }>(), {
        color: 'white',
        border: 'top'
    })

    const classes = computed(() => ({
        [`_bg-${props.color}`]: props.color,
        [`_border-${props.border}`]: props.border
    }))
</script>

<style scoped lang="scss">
    .index-scroll-section {
        --scroll-section-border-radius: 72px;

        position: relative;
        overflow: hidden;
        width: 100%;
        padding: 100px 80px;
        background-color: var(--bg-color);

        @include respond-to(tablet) {
            --scroll-section-border-radius: 40px;

            padding: 80px 32px;
        }

        @include respond-to(mobile) {
            --scroll-section-border-radius: 32px;

            width: calc(100% + 24px);
            margin: 0 -12px;
            padding: 32px 12px 120px;
        }

        &._bg-white {
            --bg-color: var(--white);
        }

        &._bg-blue {
            --bg-color: var(--indigo-50);
        }

        &._border-top {
            border-top-left-radius: var(--scroll-section-border-radius);
            border-top-right-radius: var(--scroll-section-border-radius);
        }

        &._border-full {
            border-radius: var(--scroll-section-border-radius);
        }
    }
</style>
